export default __webpack_public_path__ + "static/media/not-found.cb25e349.svg";